/* eslint-disable no-console */
import Ajv from 'ajv';

const ajv = new Ajv({
  coerceTypes: true,
  removeAdditional: true,
  useDefaults: true,
});

export default ({ payload, schema }) => {
  const data = payload;
  const validate = ajv.compile(schema);
  validate(data);
  if (validate.errors) {
    console.log('==============================');
    console.log('Schema validation error');
    console.log('==============================');
    console.log('Schema Properties');
    console.warn(Object.keys(schema?.properties ?? {}));
    console.log('==============================');
    const obj = validate.errors[0];
    const keys = Object.keys(obj);
    keys.forEach((key) => {
      console.log(key, obj[key]);
    });
  }
  return data;
};
